export default {
    methods: {
        checkUrl() {
            return new Promise((resolve, reject) => {
                let url = new window.domurl;

                if (typeof url.query.page !== 'undefined') {
                    this.options.page = parseInt(url.query.page);
                }

                if (typeof url.query.q !== 'undefined') {
                    this.searchQuery = url.query.q;
                }

                if (typeof url.query.startdate !== 'undefined') {
                    this.startDate = url.query.startdate;
                }

                if (typeof url.query.enddate !== 'undefined') {
                    this.endDate = url.query.enddate;
                }

                if (typeof url.query.sortBy !== 'undefined') {
                    this.options.sortBy = url.query.sortBy.split('|');
                }

                if (typeof url.query.sortDesc !== 'undefined') {
                    let sortDesc = url.query.sortDesc.split('|');
                    this.options.sortDesc = sortDesc.map((value) => {
                        return value === 'true';
                    });
                }

                if (typeof url.query.items !== 'undefined') {
                    this.options.itemsPerPage = Number(url.query.items);
                }

                let definitions = url.decode(url.query.toString()).split('&');
                this.$store.dispatch('table/setPredefinedFilters', definitions).then(response => {
                    this.cleanUrl()
                        .then((response) => {
                            resolve();
                        });
                });
            });
        },

        updateUrl() {
            return new Promise((resolve, reject) => {
                if (typeof this.searchQuery !== 'undefined') {
                    this.setQueryParameter(this.searchQuery);
                }

                if (typeof this.startDate !== 'undefined' && typeof this.endDate !== 'undefined') {
                    this.setDateParameter(this.startDate, this.endDate);
                }

                if (typeof this.options !== 'undefined') {
                    if (typeof this.options.page !== 'undefined') {
                        this.setPageParameter(this.options.page);
                    }

                    if (typeof this.options.itemsPerPage !== 'undefined') {
                        this.setItemsPerPageParameter(this.options.itemsPerPage);
                    }

                    if (typeof this.options.sortBy !== 'undefined' && typeof this.options.sortDesc !== 'undefined') {
                        this.setSortByParameter(this.options.sortBy, this.options.sortDesc);
                    }
                }

                if (typeof this.selectedFilters !== 'undefined') {
                    this.setFiltersParameter(this.selectedFilters);
                }

                this.cleanUrl()
                    .then((response) => {
                        resolve();
                    })
            });
        },

        resetUrl() {
            return new Promise((resolve, reject) => {
                let url = new window.domurl;
                url.clearQuery();
                window.history.replaceState({path: url.toString()}, '', url.toString());
                resolve();
            });
        },

        cleanUrl() {
            return new Promise((resolve, reject) => {
                let url = new window.domurl;

                for (let property in url.query) {
                    if (url.query.hasOwnProperty(property) && url.query[property] === '') {
                        delete url.query[property];
                    }
                }

                window.history.replaceState({path: url.toString()}, '', url.toString());
                resolve();
            });
        },


        getTabParameter() {
            let url = new window.domurl;

            if (typeof url.query.tab !== 'undefined') {
                this.activeTab = url.query.tab;
            }
        },
        setTabParameter(tab) {
            let url = new window.domurl;
            if (tab !== '') {
                url.query.tab = tab;
            } else {
                delete url.query.tab;
            }
            history.replaceState({path: url.toString()}, '', url.toString());
        },

        setQueryParameter(query) {
            let url = new window.domurl;
            if (query !== '' && query) {
                url.query.q = query;
            } else {
                delete url.query.q;
            }
            history.replaceState({path: url.toString()}, '', url.toString());
        },
        setItemsPerPageParameter(itemsPerPage) {
            let url = new window.domurl;
            url.query.items = itemsPerPage;
            history.replaceState({path: url.toString()}, '', url.toString());
        },
        setPageParameter(page) {
            let url = new window.domurl;
            url.query.page = page;
            history.replaceState({path: url.toString()}, '', url.toString());
        },
        setSortByParameter(sortBy, sortDesc) {
            let url = new window.domurl;

            if (sortBy.length) {
                url.query.sortBy = sortBy.join('|');
                url.query.sortDesc = sortDesc.join('|');
            } else {
                delete url.query.sortBy;
                delete url.query.sortDesc;
            }

            history.replaceState({path: url.toString()}, '', url.toString());
        },
        setDateParameter(startDate = null, endDate = null) {
            let url = new window.domurl;

            if (startDate) {
                url.query.startdate = startDate;
            } else {
                delete url.query.startdate;
            }

            if (endDate) {
                url.query.enddate = endDate;
            } else {
                delete url.query.enddate;
            }

            history.replaceState({path: url.toString()}, '', url.toString());
        },
        setFiltersParameter(filters) {
            let url = new window.domurl;

            for (let property in filters) {
                if (filters.hasOwnProperty(property)) {
                    url.query[property] = filters[property].join('|');
                }
            }

            history.replaceState({path: url.toString()}, '', url.toString());
        }
    }
};
